import { render, staticRenderFns } from "./deal_done.vue?vue&type=template&id=c973fa3c&scoped=true&"
import script from "./deal_done.vue?vue&type=script&lang=js&"
export * from "./deal_done.vue?vue&type=script&lang=js&"
import style0 from "./deal_done.vue?vue&type=style&index=0&id=c973fa3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c973fa3c",
  null
  
)

export default component.exports